import React from 'react';
export function useFormResetHandler({ initialValue, onReset, }) {
    const [formElement, setFormElement] = React.useState(null);
    const resetValue = React.useRef(initialValue);
    React.useEffect(() => {
        if (!formElement) {
            return undefined;
        }
        const handleReset = () => {
            onReset(resetValue.current);
        };
        formElement.addEventListener('reset', handleReset);
        return () => {
            formElement.removeEventListener('reset', handleReset);
        };
    }, [formElement, onReset]);
    const ref = React.useCallback((node) => {
        var _a;
        setFormElement((_a = node === null || node === void 0 ? void 0 : node.form) !== null && _a !== void 0 ? _a : null);
    }, []);
    return ref;
}
